/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/prop-types */
/* eslint-disable multiline-ternary */
import {
  AccessTime,
  AddRounded,
  LocationOn,
  Monitor,
  NotInterested,
} from '@mui/icons-material';
import {
  Box,
  Button,
  Chip,
  Divider,
  InputAdornment,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Avatar as MuiAvatar,
  ListItemAvatar as MuiListItemAvatar,
  Paper,
  Select,
  selectClasses,
  styled,
  Typography,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import {
  groupBy,
  uniqBy,
} from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import * as React from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getIcon } from '../../../pages/horse/Horse/components/LocationsCard';
import { getLocations } from '../../../redux/location/actions';
import { secondary } from '../../../utils/brandColors';
import { getLocationTypeDisplayName } from '../../../utils/enumHelper';
import useDebounce from '../../../utils/useDebounce';
import LocationChip from '../../LocationChip';

const Avatar = styled(MuiAvatar)(({ theme }) => ({
  width: 28,
  height: 28,
  backgroundColor: (theme.vars || theme).palette.background.paper,
  color: (theme.vars || theme).palette.text.secondary,
  border: `1px solid ${(theme.vars || theme).palette.divider}`,
}));

const ListItemAvatar = styled(MuiListItemAvatar)({
  minWidth: 0,
  marginRight: 12,
});

const GroupHeader = styled('div')(() => ({
  position: 'sticky',
  top: '-8px',
  padding: '4px 10px',
  display: 'flex',
  alignItems: 'center',
  backgroundColor: secondary[100],
  gap: 2,
}));

const GroupItems = styled('ul')({});

// Custom PaperComponent to include a footer
const CustomPaper = (props) => {
  const {
    children,
    ...other
  } = props;
  const navigate = useNavigate();
  return (
    <Paper {...other}>
      {children}
      <div
        style={{
          padding: '8px',
          borderTop: '1px solid #eee',
          display: 'block',
          width: '100%',
        }}
      >
        <Button
          size="small"
          sx={{ width: '100%' }}
          onClick={() => { navigate('/settings/locations') }}
          onMouseDown={(event) => event.preventDefault()} // Prevent blur
        >
          Manage Locations
        </Button>
      </div>
    </Paper>
  );
};

const LocationAutocomplete = ({
  onSelect,
  value,
  validation,
  multiple,
  label,
  limitTags,
  size,
  disabled,
  blurOnSelect,
  includeLocationBoards = false,
  helperText = null,
  icon,
  v2 = false,
  allOption = false,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const myTimezone = useSelector((state) => state.app.myTimezone);

  // React state
  const [search, setSearch] = React.useState('');

  // Redux state
  const isFetchingLocations = useSelector((state) => state.location.isFetchingLocations);
  const locations = useSelector((state) => state.location.locations);
  const allLocations = useSelector((state) => state.location.allLocations);
  const locationBoards = useSelector((state) => state.locationBoard.locationBoards);
  const locationsMap = useSelector((state) => state.location.locationsMap);
  const permissions = useSelector((state) => state.user.permissions);

  const debouncedSearch = useDebounce(search, 500);

  React.useEffect(() => {
    if (debouncedSearch.length > 0 || locations.content.length === 0) {
      dispatch(getLocations(0, 30, '&sort=name,asc', debouncedSearch));
    }
  }, [debouncedSearch]);

  const filteredLocationBoards = includeLocationBoards
    ? locationBoards.filter((lb) => locations.content.find((l) => l.id === lb.location.id)).map((lb) => ({
      ...lb.location,
      id: lb.id,
      locationBoard: lb,
    }))
    : []

  const sortedLocations = [...locations.content, ...filteredLocationBoards].sort((a, b) => -b.name.localeCompare(a.name))
    .sort((a, b) => -b.type.localeCompare(a.type))

  if (!v2) {
    return (
      <Autocomplete
        id="location-select-autocomplete"
        limitTags={limitTags}
        blurOnSelect={blurOnSelect || !multiple}
        multiple={multiple}
        size={size}
        onChange={onSelect}
        sx={{ width: '100%' }}
        disabled={disabled}
        loading={isFetchingLocations}
        filterOptions={(x) => x}
        options={sortedLocations}
        value={value}
        noOptionsText={(permissions.admin || permissions.owner)
          ? (
            <ListItemButton
              onClick={() => { window.location.href = '/settings/locations' }}
              dense
            >
              <ListItemIcon><LocationOn /></ListItemIcon>
              <ListItemText
                primary="No locations found"
                secondary="Create one from the location settings page"
              />
            </ListItemButton>
          )
          : 'No locations found'}
        onBlur={() => { setSearch(''); }}
        isOptionEqualToValue={(option, valueCompare) => option.id === valueCompare.id}
        groupBy={(option) => getLocationTypeDisplayName(option)}
        getOptionLabel={(option) => (option.locationBoard && `${option.locationBoard.name}`) || (option && option.name) || ''}
        renderOption={includeLocationBoards
          ? ((props, option) => {
            const {
              key,
              ...optionProps
            } = props;
            return (
              <Box
                key={key}
                component="li"
                sx={{
                  px: 0,
                  mx: 0,
                }}
                {...optionProps}
              >
                {!option.locationBoard && <LocationOn sx={{ mr: 1 }} color="secondary" />}
                {option.locationBoard && (
                  <Monitor
                    fontSize="small"
                    color="secondary"
                    sx={{
                      mr: 1,
                      ml: 2,
                    }}
                  />
                )}
                {(option.locationBoard && `${option.locationBoard.name}`) || (option && option.name) || ''}
              </Box>
            );
          })
          : undefined}
        renderGroup={(params) => (
          <li key={params.key}>
            <GroupHeader>
              {getIcon({ type: params.group })}
              <Typography>{params.group}</Typography>
            </GroupHeader>
            <GroupItems>{params.children}</GroupItems>
          </li>
        )}
        renderTags={(tagValue, getTagProps) => tagValue.map((option, index) => (
          option.locationBoard
            ? (
              <Box
                sx={{
                  marginLeft: 2,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                }}
              >
                <Typography>-</Typography>
                <LocationChip
                  key={`location-autocomplete-chip-${option.id}`}
                  {...getTagProps({ index })}
                  location={{
                    type: option.type,
                    name: 'asdfsdafs',
                  }}
                />
              </Box>
            ) : (
              <LocationChip
                key={`location - autocomplete - chip - ${option.id} `}
                {...getTagProps({ index })}
                location={locationsMap[option.id]
                  ? locationsMap[option.id][0]
                  : {
                    name: 'Location Not Found',
                    type: 'Unknown',
                    // eslint-disable-next-line react/jsx-indent
                  }}
              />
            )))}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            label={label}
            onChange={(e) => { setSearch(e.target.value); }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {isFetchingLocations
                    ? <CircularProgress color="inherit" size={20} />
                    : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
              startAdornment: icon && (
                <InputAdornment position="start">
                  <LocationOn />
                </InputAdornment>
              ),
            }}
            error={!!validation}
            helperText={(validation && validation) || helperText}
          />
        )}
        slots={{
          paper: ((permissions.owner || permissions.admin))
            ? CustomPaper
            : undefined,
        }}
      />
    );
  }

  const groupedLocations = groupBy(sortedLocations, 'type');
  const hasMoreThanOneTimezone = uniqBy(sortedLocations, 'timezone').length > 1;
  const allOptionValue = '__all__';
  let selectValue = '';
  if (value && value.id) {
    selectValue = value.id;
  } else if (allOption) {
    selectValue = allOptionValue;
  }

  return (
    <Select
      labelId="company-select"
      id="company-simple-select"
      value={selectValue}
      onChange={(event) => {
        if (event.target.value === allOptionValue) {
          onSelect(null, null);
          return;
        }
        if (event.target.value === -1) {
          window.location.href = '/settings/locations';
          navigate('/settings/locations')
          return;
        }
        const selectedLocation = sortedLocations.find((loc) => loc.id === event.target.value);
        onSelect(null, multiple ? [selectedLocation] : selectedLocation);
      }}
      displayEmpty
      inputProps={{ 'aria-label': 'Select company' }}
      fullWidth
      sx={{
        maxHeight: 56,
        width: '100%',
        p: 0,
        '&.MuiList-root': { p: '8px' },
        [`& .${selectClasses.select}`]: {
          display: 'flex',
          alignItems: 'center',
          gap: '2px',
          pl: 1,
        },
      }}
    >
      {
        sortedLocations.length === 0 && (
          <MenuItem value="">
            <ListItemAvatar>
              <Avatar alt="Sitemark web">
                <NotInterested sx={{ fontSize: '1rem' }} />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="No Locations" secondary="Create a location first" />
          </MenuItem>
        )
      }
      {
        allOption && sortedLocations.length > 0 && (
          <MenuItem key="location-autocomplete-menuitem-all" value={allOptionValue}>
            <ListItemAvatar>
              <Avatar alt="All Locations">
                <LocationOn />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary="All Locations"
            />
          </MenuItem>
        )
      }
      {
        Object.keys(groupedLocations).map((group) => (
          groupedLocations[group]
            .sort((a, b) => {
              const fullLocationA = allLocations.find((loc) => loc.id === a.id);
              const fullLocationB = allLocations.find((loc) => loc.id === b.id);
              const numA = fullLocationA ? uniqBy(fullLocationA.horseLocations, 'horse.id').length : 0;
              const numB = fullLocationB ? uniqBy(fullLocationB.horseLocations, 'horse.id').length : 0;
              return numB - numA;
            })
            .map((location) => {
              const fullLocation = allLocations.find((loc) => loc.id === location.id);
              const num = fullLocation ? uniqBy(fullLocation.horseLocations, 'horse.id').length : 0;
              return (
                <MenuItem key={`location-autocomplete-menuitem-${location.id}`} value={location.id}>
                  <ListItemAvatar>
                    {
                      location.locationBoard ? (
                        <Box sx={{ mx: '4px' }}><Monitor fontSize="small" color="secondary" />
                        </Box>
                      ) : (
                        <Avatar alt={location.name}>
                          {getIcon({ type: location.type })}
                        </Avatar>
                      )
                    }
                  </ListItemAvatar>
                  <ListItemText
                    primary={location.name}
                    slotProps={{
                      secondary: { component: 'div' },
                      primary: { variant: location.locationBoard ? 'inherit' : 'h4' },
                    }}
                    secondary={
                      location.locationBoard
                        ? (
                          <Box>{location.locationBoard.name}</Box>
                        )
                        : (
                          <Box
                            sx={{
                              display: 'flex',
                              gap: 1,
                              alignItems: 'center',
                            }}
                          >
                            {
                              hasMoreThanOneTimezone && (
                                <Chip
                                  size="small"
                                  variant="outlined"
                                  icon={<AccessTime fontSize="small" />}
                                  label={moment.tz(location.timezone).zoneAbbr()}
                                  color={location.timezone === myTimezone
                                    ? undefined
                                    : 'warning'}
                                />
                              )
                            }
                            <Chip
                              size="small"
                              variant="outlined"
                              label={num > 0
                                ? `${num} Horse${num === 1
                                  ? ''
                                  : 's'}`
                                : 'No Horses'}
                              color={num > 0
                                ? 'info'
                                : undefined}
                            />
                          </Box>
                        )
                    }
                  />
                </MenuItem>
              )
            })
        ))
      }
      <Divider sx={{ mx: -1 }} />
      <MenuItem value={-1}>
        <ListItemIcon>
          <AddRounded />
        </ListItemIcon>
        <ListItemText primary="Add Location" secondary="Manage Horse Locations" />
      </MenuItem>
    </Select>
  );
};

LocationAutocomplete.propTypes = {
  onSelect: PropTypes.func.isRequired,
  value: PropTypes.object,
  validation: PropTypes.string,
  multiple: PropTypes.bool,
  size: PropTypes.string,
  limitTags: PropTypes.number,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  blurOnSelect: PropTypes.bool,
  includeLocationBoards: PropTypes.bool,
  helperText: PropTypes.string,
  icon: PropTypes.bool,
  v2: PropTypes.bool,
};

LocationAutocomplete.defaultProps = {
  value: null,
  validation: null,
  multiple: true,
  size: 'normal',
  limitTags: 5,
  label: 'Location',
  disabled: false,
  blurOnSelect: false,
  includeLocationBoards: false,
  helperText: null,
  icon: false,
  v2: false,
};

export default LocationAutocomplete;
